import { ReactPlugin } from '@microsoft/applicationinsights-react-js'
import { ApplicationInsights } from '@microsoft/applicationinsights-web'
import { isCanceledDependency } from './aiCancelFilter'

export const appInsightsReact = new ReactPlugin()
export const appInsights = new ApplicationInsights({
    config: {
        connectionString:
            'InstrumentationKey=417924ef-4814-4e9a-880b-69516abc7d57;IngestionEndpoint=https://westeurope-5.in.applicationinsights.azure.com/;LiveEndpoint=https://westeurope.livediagnostics.monitor.azure.com/;ApplicationId=50e2ffce-054d-4094-927f-027fc4b27e89',
        extensions: [appInsightsReact],
        enableAutoRouteTracking: true,
        autoTrackPageVisitTime: true,
    },
})

if (process.env.BOOTSTRAP_ENV !== 'dev') {
    appInsights.loadAppInsights()
}
appInsights.addTelemetryInitializer(envelope => !isCanceledDependency(envelope))
// After the cancel filter: it matches on the original host-qualified name.
appInsights.addTelemetryInitializer(envelope => rewriteDependencyName(envelope))

// Application Insights names auto-tracked XHR/fetch dependencies
// "METHOD scheme://host/path", so the portal's Browser dependency views
// split the same API call into one row per host. Rewriting the name to
// "METHOD /path" (with id-like segments collapsed to {id}/{guid}) groups
// them by route; the host stays available in the dependency's target
// field and the full URL in its data field.
export function rewriteDependencyName(envelope: { baseType?: string; baseData?: { name?: string } }): void {
    if (envelope?.baseType !== 'RemoteDependencyData') {
        return
    }
    const data = envelope.baseData
    if (!data?.name) {
        return
    }
    data.name = toPathOnlyName(data.name)
}

export function toPathOnlyName(name: string): string {
    const spaceIndex = name.indexOf(' ')
    const method = spaceIndex > 0 ? name.slice(0, spaceIndex) : ''
    const url = spaceIndex > 0 ? name.slice(spaceIndex + 1) : name
    let path: string
    try {
        path = normalizePathSegments(new URL(url, window.location.origin).pathname)
    } catch {
        return name
    }
    return method ? `${method} ${path}` : path
}

const GUID_SEGMENT = /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/

function normalizePathSegments(path: string): string {
    return path
        .split('/')
        .map(segment => {
            if (/^\d+$/.test(segment)) {
                return '{id}'
            }
            if (GUID_SEGMENT.test(segment)) {
                return '{guid}'
            }
            return segment
        })
        .join('/')
}
